export enum SortDirections{
    ASC = 0,
    DESC = 1
}
export interface ColumnSortOption{
    ColumnName: string,
    SortDirection: SortDirections
}